import { FIESTA_IFRAME_MESSAGE_ACTIONS, VIEWPORT_DEVICES } from '../fiesta.constants';
import useIframeMessageHandler from './useIframeMessageHandler';
import { Editor } from 'grapesjs';

const useEditorActionsIframeListener = (editor: Editor) => {
  const actionMappings = {
    [FIESTA_IFRAME_MESSAGE_ACTIONS.UNDO]: () => {
      editor.UndoManager.undo();
    },
    [FIESTA_IFRAME_MESSAGE_ACTIONS.REDO]: () => {
      editor.UndoManager.redo();
    },
    [FIESTA_IFRAME_MESSAGE_ACTIONS.DEVICE_TYPE_CHANGE]: (viewport: string) => {
      editor.DeviceManager.select(VIEWPORT_DEVICES[viewport as keyof typeof VIEWPORT_DEVICES]?.name || 'desktop');
    },
  };
  useIframeMessageHandler(actionMappings);
};

export default useEditorActionsIframeListener;
